@if(listaAr.length > 0){
<div class="table-responsive">
  <table class="table table-striped tableDocs">
    <thead>
      <tr>
        <th scope="col" class="colNumber text-center">#</th>
        <th scope="col" class="colIcon">Tipo de archivo</th>
        @if(!verArchivoEnvio){
        @if(!OcultaSystemName){
        <th scope="col" class="colName">Archivo</th>
        }
        <th scope="col" class="colName">Archivo original</th>
        }
        @if(verArchivoEnvio){
        <th scope="col" class="colName">Archivo envío</th>
        }
        @if(verClasificacion)
        {
        <th>Clasificación</th>
        }

        <th scope="col" class="colTools"></th>
      </tr>
    </thead>
    <tbody>
      @for(ar of listaAr;track $index)
      {
      <tr class="renglon">
        <td class="text-center">{{ $index + 1 }}</td>
        <td class="text-center">
          <i class="far {{ar.claseIcono ? ar.claseIcono : 'fa-file' }} fa-lg {{ar.claseColor}}"></i>
        </td>
        @if(!verArchivoEnvio){
        @if(!OcultaSystemName){
        <td style="max-width:160px;word-wrap:break-word">
          <span [class]="ar.claseColor">{{ar.NombreSistema}}</span>
        </td>
        }
        <td style="max-width:160px;word-wrap:break-word">
          <span [class]="ar.claseColor">{{ar.NombreOriginal}}</span>
        </td>
        }
        @if(verArchivoEnvio){
        <td style="max-width:160px;word-wrap:break-word">
          <span [class]="ar.claseColor">{{ar.NombreOriginal}}</span>
        </td>
        }

        @if (verClasificacion) {
        <td>
          {{ getClasificacionDescripcion(ar.iClasificacion) }}
        </td>
        }

        <td class="botones">
          @if(!ar.EstatusDescarga && downloadfile && !ar.isAcuerdoSISE){
          <i tabindex="0"  class="fas fa-download iconDescarga" (click)="descargarArchivo(ar.IdDocumento)" (keypress.enter)="descargarArchivo(ar.IdDocumento)"></i>
          }
          @if(!ar.EstatusDescarga && downloadfile && ar.isAcuerdoSISE){
          <!-- Si es un acuerdo SISE, vamos a otro servicio -->
          <i tabindex="0" class="fas fa-download iconDescarga" (click)="descargarArcuerdo(ar.NombreOriginal, ar.isLaboral)" (keypress.enter)="descargarArcuerdo(ar.NombreOriginal, ar.isLaboral)"></i>
          }
          @if(!ar.EstatusDescarga && verPrevisualizar && !ar.isAcuerdoSISE){
          <i tabindex="0" class="fas fa-eye iconDescarga" (click)="mostrarArchivo(ar.IdDocumento)" (keypress.enter)="mostrarArchivo(ar.IdDocumento)"></i>
          }
          @if(!ar.EstatusDescarga && verPrevisualizar && ar.isAcuerdoSISE){
          <i tabindex="0" class="fas fa-eye iconDescarga" (click)="mostrarDoctoAcuerdo(ar.NombreOriginal, ar.isLaboral)" (keypress.enter)="mostrarDoctoAcuerdo(ar.NombreOriginal, ar.isLaboral)"></i>
          }
          @if(ar.EstatusDescarga){
          <i tabindex="0" class="fas fa-spinner fa-pulse"></i>
          }
          @if(!ar.EstatusDescarga && verBorrar){
          <i tabindex="0" class="far fa-trash-alt borrar" (click)="bajaArchivo(ar)" (keypress.enter)="bajaArchivo(ar)"></i>
          }
        </td>
      </tr>
      }
    </tbody>
  </table>
</div>
}